import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
// import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppSettingsService } from './app-settings.service';
import { User } from '../models/user';
import { Headers } from '@angular/http';
import { Ng2DeviceService } from 'ng2-device-detector';
import {timer} from 'rxjs/observable/timer'
import { Subject } from 'rxjs';

declare var videojs: any;
declare var jquery: any;
declare var $: any;

@Injectable()
export class AuthService {

  private headers: Headers = new Headers({ 'Content-Type': 'application/json' });
  private loggedIn = new BehaviorSubject<boolean>(false); // {1}
  public userObj = new BehaviorSubject(null);
  private user: User;
  public deviceInfo = null;
  private apiEndpoint;
  //public videoJS = videojs.default;
  constructor(private http: HttpClient, private notificationService: NotificationsService, private AppSettings: AppSettingsService, private deviceService: Ng2DeviceService) {
    if (localStorage.getItem('currentUser')) {
      this.loggedIn.next(true);
      this.userObj.next(JSON.parse(localStorage.getItem('currentUser')));
      // console.log(JSON.parse(localStorage.getItem('currentUser')));
    }
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.apiEndpoint = this.AppSettings.getConfig('API_ENDPOINT');
    // console.log(this.deviceInfo.browser);
  }

  public sessionWarningTimer$ = new Subject();
  
  /***
   * Get logged in status
   * @returns {Observable<boolean>}
   */
  get isLoggedIn() {
    return this.loggedIn.asObservable(); // {2}
  }

  get currentUser(): any {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    return this.user;
  }

  get currentUserObj(): any {
    return this.userObj.asObservable();
  }

  /**
   *
   * @param {string} username
   * @param {string} password
   * @returns {Observable<any>}
   */
  login(username: string, password: string): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'login', { EmailID: username, Password: password }).map(user => {
      // login successful if there's a jwt token in the response
      if (user.data) {
        user.data.username = username;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user.data));
        this.loggedIn.next(true);
        console.log((user.data));
        this.userObj.next(user.data);
        // console.log(this.userObj);
      }
      return user;
    });
  }

  resetPassword(username: string, password: string, newPassword: string): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'users/ResetPassword', { EmailID: username, Password: password, NewPassword: newPassword }).map(user => {
      return user;
    });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.loggedIn.next(false);
    this.userObj.next({});
    // this.createStuff();
    // bg-video-login
  }

  showNotification(title: string, message: string, type?: string): void {
    console.log(type);
    switch (type) {
      case 'success':
        this.notificationService.success(title, message, {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          clickIconToClose: true,
        });
        break;
      case 'Error':
      case 'error':
        this.notificationService.error(title, message, {
          timeOut: 5000,
          showProgressBar: true,
          pauseOnHover: true,
          clickToClose: false,
          clickIconToClose: true
        });
        break;
        case 'warn':
            this.notificationService.warn(title, message, {
              timeOut: 5000,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true
            });
            break;
        case 'info':
            this.notificationService.info(title, message, {
              timeOut: 5000,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true
            });
            break;
      default:
        this.notificationService.alert(title, message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: true,
          clickToClose: false,
          clickIconToClose: true
        });
        break;
    }
  }

  getBannerVideo() {
  
    // return this.http.get<any>(this.AppSettings.getConfig('SETTING_FILE_URL')).map(response => {
    //   return response;
    // });

    return this.AppSettings.getConfig('SETTING_FILE_URL');
  }

  createStuff(): void {
    // this.getBannerVideo().subscribe((response) => {
    //   console.log(response.videoUrl);
    //   this.crreateVideoPlayer(response.videoUrl);
    // }, (error) => {
    //   console.log(error);
    // });

    var response = this.getBannerVideo();
    this.crreateVideoPlayer(response.videoUrl);
  }

  crreateVideoPlayer(videoUrl) {
    let isChrome = (this.deviceInfo.browser === 'chrome');
    let isOpera = (this.deviceInfo.browser === 'opera');
    let isIE = (this.deviceInfo.browser === 'chrome');
    
    // console.log($('#bg-video-login'))
    const videoCont = document.createElement("div");
    // videoCont.style.cssText = "position:absolute; left:0px; top:0px;";
    // const vElement = '<video-js controls="false" id="myVideo1" class="vjs-default-skin" preload="auto" style="height: 100%;position: absolute;width: 100%"><source src="http://184.72.239.149/vod/smil:BigBuckBunny.smil/playlist.m3u8" type="application/x-mpegURL"></video-js>';
    // const vElement = '<video-js controls="false" id="myVideo1" class="vjs-default-skin" preload="auto" style="height: 100%;position: absolute;width: 100%"><source src="http://digitalmediabridge.com/streaming-videos/SportsTV/hls-sports.m3u8" type="application/x-mpegURL"></video-js>';
    // const vElement = '<video-js controls="false" id="myVideo1" class="vjs-default-skin" preload="auto" ><source src="' + videoUrl + ' " type="application/x-mpegURL"></video-js>';
    const vElement = '<video-js controls="false" id="myVideo1" class="vjs-default-skin" preload="auto"><source src="' + videoUrl + '" type="video/mp4"></video-js>';
    // const vElement ='<video id="myVideo1" autoplay muted loop id="myVideo"><source src="' + videoUrl + ' " type="video/mp4"></video>'
    videoCont.innerHTML = vElement;
    $('#bg-video-login').append(videoCont);

    if (isChrome || isOpera) {
      const player = videojs('myVideo1', { autoplay: 'muted' });	// load and start to play the video
      player.bigPlayButton.hide();
      //player.width(1920);
      //player.height(1080);
      player.fluid(true);
      player.on('ended', function () {
        player.play();
      });  // re-start the video when it is done playing
    } else if (isIE) {  // if this is an IE browser ....
      const player = videojs('myVideo1', { autoplay: true });  // load and start to play the video
      player.muted(true);
      player.autoplay();
      player.bigPlayButton.hide()
      // resize video (and div)
      // $('#video-cont  ').width(1920).height(1080);
      //player.width(1920);
      //player.height(1080);
      player.fluid(true);
      player.on('ended', function () { player.play(); });  // re-start the video when it is done playing
    }

    // const player = videojs('myVideo1', {
    //   autoplay: 'muted',
    //   controls: false
    // });
  }

  setSessionTimeout()
  {
    const SessioTimeoutMinutes = 2
    timer(5000).subscribe(this.sessionWarningTimer$)
  }
}


// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts